export default __webpack_public_path__ + "static/media/rad_bgd.96720107.jpg";